import React from 'react';
import { Youtube, Target, Zap, TrendingUp } from 'lucide-react';

const features = [
  {
    icon: Youtube,
    title: 'Optimized Tags',
    description: 'Generate SEO-friendly tags that help your videos rank higher.'
  },
  {
    icon: Target,
    title: 'Category Specific',
    description: 'Tags tailored for your video category and content type.'
  },
  {
    icon: Zap,
    title: 'Instant Generation',
    description: 'Get relevant tags in seconds with our AI-powered tool.'
  },
  {
    icon: TrendingUp,
    title: 'Trending Analysis',
    description: 'Incorporate trending keywords for better visibility.'
  }
];

export default function YouTubeFeatures() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          Why Choose Our YouTube Tag Generator?
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-center p-6 rounded-lg border border-red-200 hover:shadow-lg transition-shadow">
              <feature.icon className="w-12 h-12 text-red-500 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}